import tippy from 'tippy.js';

tippy('[data-tippy-outage-timeline]', {
  allowHTML: true,
  arrow: false,
  content({dataset: {downAt, upAt, duration}}) {
    return `
    <div class="outage-timeline-tooltip">
      <div class="row">
        <div class="item">
          <h4>DOWN</h4>
          <div class="value">${downAt}</div>
        </div>
        <div class="item">
          <h4>UP</h4>
          <div class="value">${upAt}</div>
        </div>
      </div>
      <div class="row">
        <div class="item">
          <h4>DURATION</h4>
          <div class="value">${duration}</div>
        </div>
      </div>
    </div>
    `;
  }
});

tippy('[data-tippy-overview]', {
  allowHTML: true,
  arrow: false,
  content({dataset: {displayDate, date, downtime}}) {
    return `
    <div class="overview-tooltip">
      <a href="?date=${date.trim()}">
        ${displayDate}
      </a>
      <div class="downtime">
        ${downtime}
      </div>
    </div>
    `;
  }
});
